<script setup lang="ts"></script>

<template>
  <div class="card-content">
    <slot />
  </div>
</template>

<style scoped></style>
